import { IAccommodationRecord, TAResponse3 } from 'api/tripadvisor/types';
import classNames from 'classnames';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { EmptyBlock } from 'components/common/EmptyBlock';
import { Offer } from 'components/resort/Offer';
import { Spinner } from 'components/Spinner';
import React from 'react';
import { Stars } from 'components/resort/Stars';
import { ReactComponent as SvgMarker } from 'public/assets/icons/marker.svg';

import styles from './styles.module.scss';

export interface IProps {
  isFresh: boolean;
  accommodation: IAccommodationRecord;
  offers: Array<TAResponse3.Offer>;
  areOffersLoading: boolean;
  className?: string;
  withViewDealSection?: boolean;
  dataClickId?: string;
  dataClickCategory?: string;
}

export const Accommodation = ({
  className,
  accommodation,
  areOffersLoading,
  offers,
  withViewDealSection = true,
  dataClickId,
  dataClickCategory,
}: IProps) => {
  const noOffers = (!offers || !offers.find((o) => !!o.displayPrice)) && !areOffersLoading;

  const firstOfferUrl = (offers && offers.length) ? offers[0].clickUrl : undefined;

  if (!firstOfferUrl) {
    return null;
  }

  return (
    <div className={classNames(styles.box, className, { [styles.noOffers]: noOffers })}>
      <BoxWithShadow className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          <a
            className={styles.image}
            href={firstOfferUrl}
            target="_blank"
            rel="noopener nofollow noreferrer"
            data-click-category={dataClickCategory}
            data-click-id={dataClickId}
          >
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <figure
              className={styles.image}
              style={{ backgroundImage: `url(${accommodation.photo.images.large.url})` }}
            />
            {accommodation.resort?.title_short && (
              <span className={styles.resortPin}>
                <span><SvgMarker height="15px" width="12px" /></span>
                <span>{accommodation.resort.title_short}</span>
              </span>
            )}
          </a>
        </div>
        <div className={styles.info}>
          <h3>
            <span>{accommodation.name}</span>
            {/* eslint-disable-next-line no-mixed-operators */}
            <Stars amount={+accommodation.rating} />
          </h3>
          {withViewDealSection && (
            <div>
              {areOffersLoading && <div className={styles.spinner}><Spinner /></div>}
              {!areOffersLoading && offers && offers.map((o) => (
                <Offer offer={o} key={o.clickUrl} dataClickCategory={dataClickCategory} dataClickId={dataClickId} />))}
              {!areOffersLoading && !offers && <EmptyBlock className={styles.empty} />}
            </div>
          )}
        </div>
      </BoxWithShadow>
    </div>
  );
};
